import { render, staticRenderFns } from "./TestimonialsCarousel.vue?vue&type=template&id=19e647de&scoped=true"
import script from "./TestimonialsCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialsCarousel.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsCarousel.vue?vue&type=style&index=0&id=19e647de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e647de",
  null
  
)

export default component.exports